import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { portalFetch } from "../../api/http";
import { ShellIcon } from "../../ui/icons/Icon";

/**
 * Chat dedicado (/portal/chat), como Pages/Portal/Chat/Index.razor: la página solo deja el destino de pantalla completa;
 * el chat (lista, conversación, menús y paneles) es la isla permanente de #bheli-chat-root, que se ubica sobre él.
 * Con ?returnTo= de Estadísticas muestra el regreso.
 */
export function ChatPage({ locale, search }: { locale: string; search: string }) {
  const texts = useQuery({
    queryKey: ["texts", locale, "chat-page"],
    queryFn: () => portalFetch<Record<string, string>>(`/api/portal/texts/${locale}?prefixes=NAV_CHAT,STAT_E1_TITLE`),
  });
  const title = texts.data?.["NAV_CHAT"] ?? "";
  useEffect(() => {
    if (texts.data) document.title = `${title} · Bheli`;
  }, [texts.data, title]);
  if (!texts.data) return null;
  const returnTo = new URLSearchParams(search).get("returnTo");
  const statistics =
    returnTo && !/^[a-z][a-z0-9+.-]*:/i.test(returnTo) && returnTo.startsWith("/portal/chat/estadisticas?")
      ? returnTo
      : null;
  return (
    <>
      {statistics ? (
        <a className="stat-return" href={statistics}>
          <ShellIcon name="arrow-left" />
          {texts.data["STAT_E1_TITLE"]}
        </a>
      ) : null}
      <div data-chat-fullscreen-target="" aria-label={title}></div>
    </>
  );
}
